mod.modules.define("WatchlistModals", "BaseModule", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);
		this.wsodIssue = params.wsodIssue || "";
		this.watchlistId = params.watchlistId || "";

		this.URLs = this.getURLs();
	};

	fn.prototype.getURLs = function() {
		return {
			createNewWatchlist: "~/Watchlist/Create",
			renameWatchlist: "~/Watchlist/Rename",
			deleteWatchlist: "~/Watchlist/Delete",
			addSymbol: "~/Watchlist/AddSymbol",
			addMultipleSymbol: "~/Watchlist/AddMultipleSymbol",
			addIssue: "~/Watchlist/AddIssue",
			removeIssues: "~/Watchlist/RemoveIssues",
			home: "~/Watchlist",
			sortTable: "~/Watchlist/Sort"
		};
	};

	fn.prototype.GetWatchListHomeURL = function(id) {
		var BaseURL = this.URLs.home.resolveUrl();
		var Parameters = JSON.stringify({ ID: id });
		var EncodedParameters = "?Inputs=B64ENC" + $.toBase64(Parameters);

		return BaseURL + EncodedParameters;
	};

	fn.prototype.goHome = function(id) {
		window.location = this.GetWatchListHomeURL(id);
	};

	fn.prototype.showModal = function(selector, containerEl) {
		this.$currentContent = $(selector);

		this.$currentContent.modal('show').css({
			'margin-left': function() {
				return -($(this).width() / 2);
			}
		});

		this.$currentContent.attr("data-current-wsodissue", this.wsodIssue);
	};

	fn.prototype.createNewWatchlist = function() {
		var newWatchlistName = $("[name='new_watchlist_name']").val();

		$.ajax({
			type: "POST",
			data: {
				Inputs: "B64ENC" + $.toBase64(JSON.stringify({
					NewName: newWatchlistName,
					Symbol: this.wsodIssue
				}))
			},
			context: this,
			dataType: "json",
			url: this.URLs.createNewWatchlist.resolveUrl(),
			complete: function(jqXHR, textStatus) {
			},
			success: function(Response, textStatus, jqXHR) {
				// If a symbol was added then remain on the page in context and close the modal
				if (this.wsodIssue) {
					this.closeModal("#createWatchlistModal");
				}
				else {
					if (Response.success) {
						this.goHome(Response.WatchlistID);
					} else {
						this.closeModal("#createWatchlistModal");
					}
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
			}
		});
	};

	fn.prototype.AddIssueOrSymbolToWL = function(WatchlistID, Issue, IsIssue, callback) {
		var inputs = {
			WatchListID: WatchlistID,
			WSODIssue: Issue || this.wsodIssue
		};

		if (this.sortDirection) {
			inputs.SortDirection = this.sortDirection;
		}

		if (this.sortField) {
			inputs.SortField = this.sortField;
		}

		var URL = IsIssue ? this.URLs.addIssue.resolveUrl() : this.URLs.addSymbol.resolveUrl();

		$.ajax({
			type: "POST",
			context: this,
			data: {
				Inputs: "B64ENC" + $.toBase64(JSON.stringify(inputs))
			},
			dataType: "json",
			url: URL,
			success: function(response, textStatus, jqXHR) {
				if (response.success) {
					this.closeModal(this.$currentContent);
					this.clearErrors();
					mod.observer.trigger("watchlist - update");
				} 
				else if (response.error == "full") {
					this.showError("The maximum number of holdings have already been added to this watchlist.");
				}
				else {
					this.showError("The symbol could not be added to your watchlist.");
				}

				// Set the watchlistId as a param so we can inspect it from the callback
				response.watchlistId = WatchlistID;

				if (callback != null) {
					callback(response);
				}
			}
		});
	};

	

	fn.prototype.showError = function(text) {
		this.$currentContent.find("p.error-text").show().text(text);
	};

	fn.prototype.clearErrors = function() {
		this.$currentContent.find("p.error-text").hide().text("");
	};

	fn.prototype.addIssue = function(WSODIssue, WatchListID) {
		var wsodIssue = WSODIssue || $("#addToWatchlistSearchModal").attr("data-current-wsodissue");
		var WatchlistID = WatchListID || this.$currentContent.find("select option:selected").attr("data-watchlist-id");
		this.AddIssueOrSymbolToWL(WatchlistID, wsodIssue, true);
	};

	fn.prototype.addSymbol = function(callback) {
		var WatchlistID = $("#addToWatchlistSearchModal select option:selected").attr("data-watchlist-id");
		var Symbol = $("#addToWatchlistSearchModal input.symbol-search").val();
		this.AddIssueOrSymbolToWL(WatchlistID, Symbol, false, callback);
	};

	fn.prototype.closeModal = function(el) {
		this.clearErrors();
		$(el).modal('hide');
	};

	fn.prototype.events = {
		"button[data-action]": {
			"click": function(e, $el) {
				var action = $el.attr("data-action");

				switch (action) {
					case "create-new-watchlist":
						this.createNewWatchlist();
						break;
					case "gotoWatchList":
						this.goHome($el.data("watchlist-id"));
						break;
					case "addIssue":
						this.addIssue();
						break;
					default:
						break;
				}
			}
		},
		"button[data-action='cancel']": {
			"click": function(e, $el) {
				this.closeModal($el.closest("div.modal"));
			}
		},
		".modalForm select": {
			"change": function(e, $el) {
				this.clearErrors();
			}
		}
	};
});